<mat-card class="breadcrumb mt-3">
    <div class="row">
      <div class="col-md-10">
        <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
        <!--<mat-icon>arrow_forward_ios</mat-icon>-->
        <a [routerLink]="['/feedback/report']">Feedback Reporting</a>
      </div>
      <div class="col-md-2 text-right">
            <div *ngIf="params.questions.thumbs.length || params.questions.choice.length">
                 <button type="button" class="btn btn-primary" (click)="submit()">Run Report</button>
            </div>

    </div>
    </div>
  </mat-card>

  <div class="row mb-4">

    <div class="col-3">
        <mat-card class="">
            <div class="d-flex justify-content-start">
                <div class="count-badge active" >1</div>
                <h2 class="mat-title mb-0 ml-3">Select Dates</h2>
            </div>
        </mat-card>
        <mat-card class="mt-2">

            <div class="mt-2">
                <mat-form-field style="display: block">
                    <input type="search" matInput (dateChange)="updateDates()" [(ngModel)]="dateStart" (click)="dateStartPicker.open()" [matDatepicker]="dateStartPicker" placeholder="Select from">
                    <mat-datepicker #dateStartPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="mt-2">
                <mat-form-field style="display: block">
                    <input type="search" matInput (dateChange)="updateDates()" [(ngModel)]="dateEnd" (click)="dateEndPicker.open()" [matDatepicker]="dateEndPicker" placeholder="Select to">
                    <mat-datepicker #dateEndPicker></mat-datepicker>
                </mat-form-field>
            </div>

        </mat-card>
    </div>

    <div class="col-3">
        <mat-card class="">
            <div class="d-flex justify-content-start">
                <div class="count-badge active" >2</div>
                <h2 class="mat-title mb-0 ml-3">Select Brand</h2>
            </div>
        </mat-card>
        <mat-card class="mt-2" *ngIf="businesses.length">

            <div class="mt-2">
                <div (click)="selectBusiness(b.id)" *ngFor="let b of businesses" class="d-flex justify-content-between mt-2 option-box">
                    {{b.name}}
                    <a>
                        <i class="fa fa-check-circle" [ngClass]="{'active' : b.id === params.business}"></i>
                    </a>
                </div>
            </div>

        </mat-card>
    </div>

    <div class="col-3">
        <mat-card class="">
            <div class="d-flex justify-content-start align-items-center">
                <div class="count-badge active" >3</div>
                <h2 class="mat-title mb-0 ml-3">Select Template</h2>
            </div>
        </mat-card>
        <mat-card class="mt-2" *ngIf="templates.length">

            <div class="mt-2">
                <div (click)="selectTemplate(t.id)" *ngFor="let t of templates" class="d-flex justify-content-between mt-2 option-box">
                    {{t.name}}
                    <a>
                        <i class="fa fa-check-circle" [ngClass]="{'active' : t.id === params.template}"></i>
                    </a>
                </div>
            </div>

        </mat-card>
    </div>

    <div class="col-3">
        <mat-card class="">
            <div class="d-flex justify-content-start align-items-center">
                <div class="count-badge active" >4</div>
                <h2 class="mat-title mb-0 ml-3">Select Questions</h2>
            </div>
        </mat-card>
        <mat-card class="mt-2" *ngIf="questions.choice.length">

            <div class="mt-2">
                <h2 class="mat-title mb-3 ml-3">Multiple Choice Questions</h2>
                <div (click)="selectSummary(q.id)" *ngFor="let q of questions.choice" class="d-flex justify-content-between mt-2 option-box">
                    {{q.text}}
                    <a>
                        <i class="fa fa-check-circle" [ngClass]="{'active' : params.summary === q.id}"></i>
                    </a>
                </div>
            </div>
        </mat-card>

        <mat-card class="mt-2" *ngIf="params.summary">
            <h2 class="mat-title mb-3 ml-3">Filter feedback score by</h2>
            <ng-container *ngFor="let c of questions.choice">
                <ng-container *ngIf="params.summary === c.id">
                <div (click)="setExclusion(p)" *ngFor="let p of c.placeholder" class="d-flex justify-content-between mt-2 option-box">
                    {{p}}
                    <a>
                        <i class="fa fa-check-circle" [ngClass]="{'active' : params.exclusion === p}"></i>
                    </a>
                </div>

                </ng-container>

            </ng-container>

        </mat-card>

        <mat-card class="mt-2" *ngIf="questions.thumbs.length">


            <div class="mt-2">
                <h2 class="mat-title mb-3 ml-3">Feedback Score Questions</h2>

                <div (click)="selectQuestion(q.id, 'thumbs')" *ngFor="let q of questions.thumbs" class="d-flex justify-content-between mt-2 option-box">
                    {{q.text}}
                    <a>
                        <i class="fa fa-check-circle" [ngClass]="{'active' : questionSelected(q.id, 'thumbs')}"></i>
                    </a>
                </div>
            </div>



        </mat-card>

    </div>

</div>




<ng-container *ngIf="data">
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Results for period {{dateStart | date: 'dd/MM/yyyy'}} to {{dateEnd | date: 'dd/MM/yyyy'}}</h5>
                <a class="close hover" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">



        <mat-card class="mt-4" *ngIf="data.questions.length">
                <h4 class="mat-title mb-3">Feedback score {{data.templateWeekPerc}}% </h4>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Score</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let q of data.questions">
                            <td>{{q.text}}</td>
                            <td>{{q.perc}}%</td>
                            <td><img [src]="q.thumb" /></td>
                        </tr>
                    </tbody>
                </table>


            </mat-card>


            <ng-container *ngFor="let s of data.summaries">
                <mat-card class="mt-4">
                    <h4 class="mat-title mb-3">{{s.question.text}}</h4>

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Response</th>
                                <th>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let a of s.answers">
                                <td>{{a.response}}</td>
                                <td>{{a.responses}}</td>
                            </tr>
                        </tbody>
                    </table>

                </mat-card>

            </ng-container>


            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show modal-slide-show"></div>

</ng-container>


















